"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookEncoding = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class BookEncoding {
  /**
   * Parses an RFC 2046 style Media Type, aka. MIME type
   */
  static parse(encoding) {
    if (!encoding) {
      return this.plainText();
    }
    let types = /^([a-z0-9][a-z0-9-]*)(\/([a-z0-9][a-z0-9-+.]*))?\s*/.exec(encoding);
    if (!types) {
      return this.plainText();
    }
    let type = types[1];
    let subtype = types[3];
    let remainder = encoding.slice(types[0].length);
    let parameters;
    for (let match of remainder.matchAll(/\s*([a-z0-9][a-z0-9-]*)=([^;]*)/ig)) {
      if (!parameters) {
        parameters = {};
      }
      parameters[match[1]] = match[2].trim();
    }
    return new BookEncoding(type, subtype, parameters);
  }
  static plainText() {
    return new BookEncoding("text", "plain");
  }
  constructor(type, subtype, parameters = null) {
    (0, _defineProperty2.default)(this, "type", void 0);
    (0, _defineProperty2.default)(this, "subtype", void 0);
    (0, _defineProperty2.default)(this, "parameters", void 0);
    (0, _defineProperty2.default)(this, "name", void 0);
    (0, _defineProperty2.default)(this, "description", void 0);
    this.type = type;
    this.subtype = subtype;
    this.parameters = parameters;
    this.name = this.fullType();
    this.description = null;
  }

  /**
   * Returns the full type without parameters.
   *
   * @return {string}
   */
  fullType() {
    let full = this.type;
    if (this.subtype) {
      full += "/" + this.subtype;
    }
    return full;
  }

  /**
   * Checks if this encoding matches the given parameters.
   */
  is(type, subtype = null) {
    if (this.type !== type) {
      return false;
    }
    return !(subtype !== null && this.subtype !== subtype);
  }
  isEncrypted() {
    return !!this.parameter('crypt');
  }
  encryption() {
    return this.parameter('crypt');
  }
  toString() {
    let val = this.fullType();
    if (this.parameters) {
      return [val].concat(Object.entries(this.parameters).map(entry => `${entry[0]}=${entry[1]}`)).join('; ');
    }
    return val;
  }
  parameter(key) {
    if (this.parameters) {
      return this.parameters[key];
    } else {
      return null;
    }
  }
  set(key, value) {
    if (!value) {
      if (this.parameters && this.parameters[key]) {
        delete this.parameters[key];
      }
    } else {
      if (!this.parameters) {
        this.parameters = {};
      }
      this.parameters[key] = value;
    }
  }
  clone() {
    return BookEncoding.parse(this.toString());
  }
}
exports.BookEncoding = BookEncoding;
//# sourceMappingURL=BookEncoding.js.map